/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#ttd[_ngcontent-%COMP%]{display:block;cursor:pointer;width:450px;height:300px;background-color:#fff;border:1px solid #333}"];
export { styles as styles };
